import type { PublicProps as Props } from './typings'
import { PureComponent } from 'react'
import { Field as FinalFormField, FieldRenderProps } from 'react-final-form'

import { isDeepEqual } from '@/server-data'

import DropDownField from './DropDownField'

export default class DropDownFieldFieldWrapper extends PureComponent<Props> {
  render() {
    const { name, ...props } = this.props
    return (
      <FinalFormField
        {...props}
        name={name}
        isEqual={isDeepEqual}
        render={(formProps: FieldRenderProps<any>) => {
          return <DropDownField {...this.props} formProps={formProps} />
        }}
      />
    )
  }
}
